import { httpAnonymousRequest } from 'httpRequest'
import { TenantIdentifierInfoContract } from 'models'

const TENANT_IDENTIFIER_INFO_PREFIX = '/tenant-info'

const tenantIdentifierInfoService = {
    getTenantIdentifierInfo: () =>
        httpAnonymousRequest.get<TenantIdentifierInfoContract>(
            TENANT_IDENTIFIER_INFO_PREFIX,
        ),
}

export default tenantIdentifierInfoService
